import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gradient-form flex items-center justify-center h-screen w-screen" }
const _hoisted_2 = { class: "h-full lg:w-6/12 w-9/12" }
const _hoisted_3 = { class: "g-6 flex h-full flex-wrap items-center justify-center text-neutral-800 dark:text-neutral-200" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "block rounded-[20px] shadow-login" }
const _hoisted_6 = { class: "g-0 lg:flex lg:flex-wrap login-block-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center rounded-t-[20px] lg:rounded-l-[20px] lg:rounded-tr-none bg-cover lg:w-4/12 bg-[url('@/assets/login/polar-bear.svg')]" }, null, -1)
const _hoisted_8 = { class: "px-4 md:px-0 py-8 md:py-0 lg:w-2/3 bg-white bg-opacity-10 rounded-[20px] lg:rounded-l-none lg:rounded-r-[20px]" }
const _hoisted_9 = { class: "md:mx-6 md:p-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-center flex flex-col items-center justify-center mb-5 text-white" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 text-lg md:text-2xl font-bold" }, " Reset password ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_FormKit, {
                    type: "form",
                    actions: false,
                    onSubmit: _ctx.resetPassword
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        type: "password",
                        name: "password",
                        label: "New password",
                        validation: "required",
                        "validation-visibility": "submit",
                        "suffix-icon": "eyeClosed",
                        onSuffixIconClick: _ctx.handleIconClick,
                        "outer-class": "login-input mb-5"
                      }, null, 8, ["onSuffixIconClick"]),
                      _createVNode(_component_FormKit, {
                        type: "password",
                        name: "password_confirm",
                        label: "Confirm password",
                        validation: "required|confirm",
                        "validation-visibility": "submit",
                        "validation-label": "Password confirmation",
                        "suffix-icon": "eyeClosed",
                        onSuffixIconClick: _ctx.handleIconClick,
                        "outer-class": "login-input mb-2"
                      }, null, 8, ["onSuffixIconClick"]),
                      _createVNode(_component_FormKit, { type: "submit" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Reset password ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}